<template>
    <div v-if="isVisible" :class="[item.data.htmloptions, isInvalid ? 'is-invalid' : '']" class="form-item select-item">

        <div class="select-item__select" @click="toggleOptions">
            <span> {{ selectedOption.label }}</span>
            <i class="icon-arrow-down"></i>
        </div>

        <ul v-if="showOptions" class="select-item__options">
            <li
                v-for="answer in answeroptions"
                :key="answer.id"
                @click="setOption(answer)"
            >
                {{ answer.label }}
            </li>
        </ul>

        <Label :errors="errors" :is-invalid="isInvalid" :item="item"/>

        <input v-model="selectedOption.value" :name="item.data.id" type="hidden"/>
    </div>
</template>

<script>
import Label from "../components/Label.vue";

import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";

export default {
    name: 'Country',
    components: {Label},
    mixins: [errorMixin, logicMixin],
    props: {
        item: {
            type: Object
        },
        answerOptions: {
            type: Object
        },
    },
    data: function () {
        return {
            selected: null,
            showOptions: false,
            selectedOption: ''
        };
    },
    computed: {
        answeroptions() {
            const answeroptions = this.answerOptions[this.item.data.id] ? [...this.answerOptions[this.item.data.id]] : [...this.item.data.answeroptions];

            if (this.item.data.alphabeticalorder) {
                return answeroptions.sort((a, b) => {
                    if (a.label < b.label) {
                        return -1;
                    }
                    if (a.label > b.label) {
                        return 1;
                    }
                    return 0;
                });
            }

            return answeroptions;
        }
    },
    methods: {
        setOption(answer) {
            this.selectedOption = answer;
            this.showOptions = false;
        },
        toggleOptions() {
            this.showOptions = !this.showOptions;
        }
    }
};
</script>